import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Productos from "../components/Productos";

import Switcher from "../components/switcher";
import VideoBackground from "../components/VideoBackground";
import useStore from "../store/useStore";
const productos = [
  {
    title: "Gestión de Regímenes RAF",
    description: "Importacion y Exportacion Temporal, Reposición de Stock",
  },
  {
    title: "Registro de DRIPA y CTIT",
    description: "Control basado en información oficial de las Aduanas",
  },
  {
    title: "Alternativas",
    description: "Importación de relaciones para generación de descargas",
  },
  {
    title: "Priorización de Descargas",
    description: "Registro de insumos alternativos para consumos",
  },
  {
    title: "Integración ERP/Legacy",
    description:
      "Permite la flexibilidad de adaptarse a Sistemas Internos para procesamiento de descargas",
  },
  {
    title: "Conexión con ARCA",
    description: "Integración con WS de Grandes Operadores.",
  },
  {
    title: "Alertas de punta a punta",
    description:
      "Notificaciones configurables en cada uno de los estadios de la operación",
  },
];
export default function Mre() {
  const { mreHeroes, getMreHeroes } = useStore();
  const urlApi = "https://api.institucional.global.sidom.io";

  useEffect(() => {
    getMreHeroes();
  }, [getMreHeroes]);
  return (
    <div className="bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-light">
      <Navbar />
      <div>
        {mreHeroes?.length === 0 || !mreHeroes ? (
          <VideoBackground
            video="/placeholder.mp4"
            titulo1="Cargando..."
            titulo2="Espere un momento"
            textbutton="SOLICITAR DEMO"
            logo="/placeholder-logo.png"
          />
        ) : (
          mreHeroes.map((item, index) => (
            <VideoBackground
              key={index}
              video={`${urlApi}${item.video[0]?.url}`}
              titulo1={item.titulo}
              titulo2={item.text}
              textbutton="SOLICITAR DEMO"
              logo={`${urlApi}${
                item.img[0]?.formats?.thumbnail?.url ||
                item.img?.url ||
                "/placeholder-logo.png"
              }`}
            />
          ))
        )}
      </div>
      <section className="bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-light">
        <div className="container mb-4 flex flex-col items-center justify-center ">
          <div>
            <h2 className="text-2xl font-bold mb-8">Beneficios</h2>
          </div>
          <div>
            <Productos productos={productos} />
          </div>
        </div>
      </section>
      <div>
        <div className="flex  justify-start text-xl font-bold mb-4 p-4">
          <h5>Flujo de MRE Exportaciones</h5>
        </div>
        <div className=" flex  justify-center items-center ">
          <img
            src="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/diagrams/flujo_MRE_EXPO.png"
            alt=" mre"
            className="  w-4/5 rounded-lg"
          />
        </div>
      </div>
      <div>
        <div className="flex  justify-start text-xl font-bold mb-4 p-4 ">
          <h5>Flujo de MRE Importaciones</h5>
        </div>
        <div className=" flex  justify-center items-center ">
          <img
            src="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/diagrams/flujo_MRE_IMPO.png"
            alt=" mre"
            className=" w-4/5 rounded-lg "
          />
        </div>
      </div>
      {/* <div className="space-y-8 p-4 lg:p-8">
        <InfoCard
          title="¿Tienes alguna pregunta?"
          description="Nos pondremos en contacto para que puedas saltar al próximo nivel."
          buttonText="Contáctanos"
          buttonLink="/contactus"
          backgroundColor="bg-orange-500"
          iconSrc="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/message.png"
        />
        <InfoCard
          title="Global trade"
          description="La única plataforma 100% Web/SaaS para la gestión punta a punta de la operatoria de importadores y exportadores."
          buttonText="Quiero saber más"
          buttonLink="/"
          backgroundColor="bg-sidom-blue"
          iconSrc="https://sidomsuite.com/wp-content/uploads/2024/09/01.png"
        />
      </div> */}
      <Footer />
      <Switcher />
    </div>
  );
}
